import Axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import api from "../../common/api";
import Input from "@material-ui/core/Input";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  LinearProgress,
  Link,
  Select,
  TextField
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ControlPointDuplicateIcon from "@material-ui/icons/ControlPointDuplicate";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DropzoneArea } from "material-ui-dropzone";
import NumberFormat from "react-number-format";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { set } from "react-ga";

const useStyles = theme =>
  makeStyles(theme => ({
    root: {
      width: "100%"
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    },
    label: {
      fontSize: theme.typography.pxToRem(13),
      color: theme.palette.text.secondary
    },
    iconButton: {
      color: "red"
    }
  }));
const classes = useStyles();

const AuthorizationMatrix = () => {
  const [authorizationMatrix, setAuthorizationMatrix] = useState({
    tasks: [],
    work_order_types: [
      {
        id: 0,
        role_id: "",
        value: "",
        description: "",
        wo_type_id: ""
      }
    ],
    media: []
  });
  const [error, setError] = useState(null);
  const [dialogModal, setDialog] = useState({
    open: false,
    message: "",
    errors: false,
    idContract: null
  });
  const [loading, setLoading] = useState(true);
  const [workOrderTypes, setWorkOrderTypes] = useState([]);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [files, setFiles] = useState([]);
  //const [tasks, setTasks] = useState({predictive:[], others:[], sinisters });
  const getParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("idContract")) {
      setIsReadOnly(false);
      setAuthorizationMatrix({
        ...authorizationMatrix,
        contract_id: searchParams.get("idContract")
      });
    } else if (searchParams.get("idMatrix")) {
      setIsReadOnly(false);
      setAuthorizationMatrix({
        ...authorizationMatrix,
        id: searchParams.get("idMatrix")
      });
      getMatrix(searchParams.get("idMatrix"));
    } else if (searchParams.get("vMatrix")) {
      setIsReadOnly(true);
      setAuthorizationMatrix({
        ...authorizationMatrix,
        id: searchParams.get("idMatrix")
      });
      getMatrix(searchParams.get("idMatrix"));
    }
    getWorkOrderTypes();
    return;
  };
  useEffect(() => {
    getParams();
  }, [window.location.search]);

  const getWorkOrderTypes = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.dropdowns().ot(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setWorkOrderTypes(res.data.work_order_types);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getMatrix = async idMatrix => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.authorization_matrix().get(idMatrix), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        let response = res.data;
        if (
          !response.work_order_types ||
          response.work_order_types.length === 0
        ) {
          response.work_order_types = [
            {
              id: 0,
              role_id: "",
              value: "",
              description: ""
            }
          ];
        }
        setAuthorizationMatrix({
          ...authorizationMatrix,
          ...response
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handlePreview = () => {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.authorization_matrix().preview(authorizationMatrix.id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setDialog({
          ...dialogModal,
          open: true,
          message: res.data,
          errors: false
        });
        return true;
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleSubmit = () => {
    var formData = new FormData();
    formData.set(
      "authorization_matrix[name]",
      authorizationMatrix.name ? authorizationMatrix.name : ""
    );
    formData.set(
      "authorization_matrix[description]",
      authorizationMatrix.description ? authorizationMatrix.description : ""
    );
    formData.set(
      "authorization_matrix[contract_id]",
      authorizationMatrix.contract_id ? authorizationMatrix.contract_id : ""
    );
    var id = 0;
    authorizationMatrix.work_order_types.forEach(element => {
      if (element.id) {
        formData.append(
          "authorization_matrix[work_order_types][" + id + "][id]",
          element.id
        );
      }
      formData.append(
        "authorization_matrix[work_order_types][" + id + "][role_id]",
        element.role_id ? element.role_id : ""
      );
      formData.append(
        "authorization_matrix[work_order_types][" + id + "][wo_type_id]",
        element.wo_type_id ? element.wo_type_id : ""
      );
      formData.append(
        "authorization_matrix[work_order_types][" + id + "][description]",
        element.description ? element.description : ""
      );
      formData.append(
        "authorization_matrix[work_order_types][" + id + "][value]",
        element.value ? element.value : ""
      );

      id++;
    });
    files.forEach(file => {
      formData.append("authorization_matrix[media][]", file);
    });
    const token = localStorage.getItem("userToken");
    var url = api.authorization_matrix().post();
    if (authorizationMatrix.id) {
      formData.append("_method", "patch");
      formData.set("authorization_matrix[id]", authorizationMatrix.id);
      url = api.authorization_matrix().patch(authorizationMatrix.id);
    }
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setDialog({
          ...dialogModal,
          open: true,
          message: "Matriz de autorización guardada correctamente",
          errors: false
        });
      })
      .catch(err => {
        setDialog({
          ...dialogModal,
          open: true,
          message: "Error al guardar la matriz de autorización",
          errors: true
        });
      });
  };
  if (loading) return <LinearProgress />;
  return (
    <>
      <Dialog
        open={dialogModal.open}
        fullWidth
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle ialogTitle id="responsive-dialog-title">
          {"Matriz de autorización"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              dangerouslySetInnerHTML={{ __html: dialogModal.message }}
            ></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions disableSpacing="false">
          {dialogModal.errors ? (
            <Button
              onClick={() => {
                setDialog({ ...dialogModal, open: false });
              }}
              variant="contained"
              color="primary"
            >
              Aceptar
            </Button>
          ) : (
            <Button
              onClick={() => {
                window.location.href = `/contracts`;
              }}
              variant="contained"
              color="primary"
            >
              Aceptar
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <TextField
        disabled={isReadOnly}
        id="matrixName"
        placeholder="Ingrese un nombre de matriz de autorización"
        fullWidth
        required
        value={authorizationMatrix.name}
        name="matrixName"
        margin="normal"
        inputProps={{
          style: { fontSize: "0.75rem" }
        }}
        InputLabelProps={{
          shrink: true
        }}
        onChange={event => {
          setAuthorizationMatrix({
            ...authorizationMatrix,
            name: event.target.value
          });
        }}
      />
      <TextField
        id="description"
        disabled={isReadOnly}
        placeholder="Ingrese observaciones"
        fullWidth
        value={authorizationMatrix.description}
        name="description"
        margin="normal"
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{
          style: { fontSize: "0.75rem" }
        }}
        onChange={event => {
          setAuthorizationMatrix({
            ...authorizationMatrix,
            description: event.target.value
          });
        }}
      />
      {authorizationMatrix.work_order_types.map((workOrderType, index) => {
        if (workOrderType.deleted_at) return null;
        return (
          <div key={index}>
            <FormControl
              className="m-2"
              style={{ minWidth: 150, fontSize: "0.75rem" }}
            >
              <InputLabel
                htmlFor="grouped-native-select"
                autoWidth="true"
                style={{ minWidth: 150, fontSize: "0.75rem" }}
              >
                Selecione el tipo de OT
              </InputLabel>
              <Select
                native
                defaultValue=""
                disabled={isReadOnly}
                error={workOrderType.value > 0 && workOrderType.role_id === ""}
                style={{ minWidth: 150, fontSize: "0.75rem" }}
                id={`work-order-type-${workOrderType.role_id}`}
                value={workOrderType.wo_type_id}
                input={<Input id="grouped-native-select" />}
                onChange={event => {
                  const updatedWorkOrderTypes = [
                    ...authorizationMatrix.work_order_types
                  ];
                  updatedWorkOrderTypes[index] = {
                    ...updatedWorkOrderTypes[index],
                    wo_type_id: event.target.value
                  };

                  setAuthorizationMatrix({
                    ...authorizationMatrix,
                    work_order_types: updatedWorkOrderTypes
                  });
                }}
              >
                <option value="" />
                {workOrderTypes.map((workOrderType, index) => (
                  <option key={index} value={workOrderType.id}>
                    {workOrderType.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <NumberFormat
              label="Monto"
              disabled={isReadOnly}
              className="ammount m-2"
              InputProps={{ style: { width: "5rem", fontSize: "0.75rem" } }}
              name={`workOrderType-${index}-ammount`}
              onValueChange={values => {
                const { floatValue } = values;
                const updatedWorkOrderTypes = [
                  ...authorizationMatrix.work_order_types
                ];
                updatedWorkOrderTypes[index] = {
                  ...updatedWorkOrderTypes[index],
                  value: floatValue
                };

                setAuthorizationMatrix({
                  ...authorizationMatrix,
                  work_order_types: updatedWorkOrderTypes
                });
              }}
              value={workOrderType.value}
              thousandSeparator="."
              decimalSeparator=","
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
              isAllowed={values => {
                const { formattedValue, floatValue } = values;
                return formattedValue === "" || floatValue >= 1;
              }}
            />
            <FormControl
              className="m-2"
              style={{ minWidth: 150, fontSize: "0.75rem" }}
            >
              <InputLabel
                htmlFor="grouped-native-select"
                autoWidth="true"
                style={{ minWidth: 150, fontSize: "0.75rem" }}
              >
                Selecione el rol
              </InputLabel>
              <Select
                native
                defaultValue=""
                disabled={isReadOnly}
                error={workOrderType.value > 0 && workOrderType.role_id === ""}
                style={{ minWidth: 150, fontSize: "0.75rem" }}
                id={`work-order-type-${workOrderType.role_id}`}
                value={workOrderType.role_id}
                input={<Input id="grouped-native-select" />}
                onChange={event => {
                  const updatedWorkOrderTypes = [
                    ...authorizationMatrix.work_order_types
                  ];
                  updatedWorkOrderTypes[index] = {
                    ...updatedWorkOrderTypes[index],
                    role_id: event.target.value
                  };

                  setAuthorizationMatrix({
                    ...authorizationMatrix,
                    work_order_types: updatedWorkOrderTypes
                  });
                }}
              >
                <option value="" />
                <optgroup label="AutoCorp">
                  <option value="4">AutoCorp Verificador</option>
                  <option value="5">AutoCorp Aprobador</option>
                  <option value="6">AutoCorp Aprobador + 1</option>
                </optgroup>
                <optgroup label="Cliente">
                  <option value="1">Cliente Verificador</option>
                  <option value="2">Cliente Aprobador</option>
                  <option value="3">Cliente Aprobador + 1</option>
                </optgroup>
              </Select>
            </FormControl>
            <Tooltip title={workOrderType.description} aria-label="add">
              <TextField
                disabled={isReadOnly}
                label="Comentarios"
                type="text"
                className="m-2"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{ style: { width: "15rem", fontSize: "0.75rem" } }}
                id={`workOrderType-${index}-description`}
                value={workOrderType.description}
                name={`workOrderType-${index}-description`}
                onChange={event => {
                  const updatedWorkOrderTypes = [
                    ...authorizationMatrix.work_order_types
                  ];
                  updatedWorkOrderTypes[index] = {
                    ...updatedWorkOrderTypes[index],
                    description: event.target.value
                  };

                  setAuthorizationMatrix({
                    ...authorizationMatrix,
                    work_order_types: updatedWorkOrderTypes
                  });
                }}
                margin="normal"
              />
            </Tooltip>
            {!isReadOnly && (
              <div
                class="mt-4"
                style={{ width: "min-content", display: "inline-flex" }}
              >
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={() => {
                    const updatedWorkOrderTypes = [
                      ...authorizationMatrix.work_order_types
                    ];
                    updatedWorkOrderTypes[index] = {
                      ...updatedWorkOrderTypes[index],
                      deleted_at: new Date()
                    };

                    setAuthorizationMatrix({
                      ...authorizationMatrix,
                      work_order_types: updatedWorkOrderTypes
                    });
                  }}
                  disabled={
                    workOrderType.role_id === "" || workOrderType.value === ""
                  }
                >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={() => {
                    let updatedWorkOrderTypes = [
                      ...authorizationMatrix.work_order_types
                    ];
                    updatedWorkOrderTypes.push({
                      ...workOrderType,
                      id: 0,
                      role_id: "",
                      value: "",
                      wo_type_id: "",
                      description: ""
                    });
                    setAuthorizationMatrix({
                      ...authorizationMatrix,
                      work_order_types: updatedWorkOrderTypes
                    });
                  }}
                >
                  <AddIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={() => {
                    let updatedWorkOrderTypes = [
                      ...authorizationMatrix.work_order_types
                    ];
                    updatedWorkOrderTypes.push({
                      ...workOrderType,
                      id: 0,
                      role_id: workOrderType.role_id,
                      value: workOrderType.value,
                      wo_type_id: workOrderType.wo_type_id,
                      description: workOrderType.description
                    });
                    setAuthorizationMatrix({
                      ...authorizationMatrix,
                      work_order_types: updatedWorkOrderTypes
                    });
                  }}
                >
                  <ControlPointDuplicateIcon className={classes.deleteIcon} />
                </IconButton>
              </div>
            )}
          </div>
        );
      })}
      <div style={{ width: "30rem" }}>
        <DropzoneArea
          onChange={files => {
            setFiles(files);
          }}
          dropzoneText="Arrastra los archivos aquí o buscalos"
          showPreviews="true"
          showPreviewsInDropzone={false}
          showFileNamesInPreview="true"
          showFileNames="true"
        />
      </div>
      <div className="row"></div>
      {authorizationMatrix.media.length > 0 ? (
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Nombre del archivo</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {authorizationMatrix.media.map((val, idx) => (
              <TableRow key={val.id}>
                <TableCell>{val.name}</TableCell>
                <TableCell>
                  <Link href={api.media_download + "/" + val.id}>
                    <ArrowDownwardIcon />
                    Descargar
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        ""
      )}{" "}
      {!isReadOnly && (
        <div>
          <Button
            type="submit"
            variant="contained"
            className="mt-3 ml-1 mr-1"
            color="primary"
            onClick={() => {
              handleSubmit();
            }}
          >
            Guardar
          </Button>
        </div>
      )}
      {authorizationMatrix.id > 0 && (
        <Button
          variant="contained"
          className="mt-3 ml-1 mr-1"
          color="primary"
          onClick={() => {
            handlePreview();
          }}
        >
          Previsualizar
        </Button>
      )}
      {authorizationMatrix.id > 0 && (
        <Button
          className="mt-3 ml-1 mr-1"
          href={api.authorization_matrix().export(authorizationMatrix.id)}
          variant="contained"
          color="primary"
        >
          Descargar
        </Button>
      )}{" "}
      <Button
        variant="contained"
        className="mt-3 ml-1 mr-1"
        color="secondary"
        href={
          "/authorizationMatrices?idContract=" + authorizationMatrix.contract_id
        }
      >
        Volver
      </Button>
    </>
  );
};

export default AuthorizationMatrix;
